<template>
  <SkinnyBanner page="landing" />
  <RevContainer class="mb-16 mt-32" data-spec="body">
    <h1 class="heading-1">{{ company }}</h1>

    <MainSellerInfo :country :country-code :rating :years="ageInYears" />

    <RevTabs
      class="mt-32"
      :label="i18n(translations.sellerPageTabsLabel)"
      scrollable
      variant="flexible"
    >
      <RevTabItem
        :active="activeTab === 'reviews'"
        :label="i18n(translations.sellerPageReviewsTab)"
        @click="activeTab = 'reviews'"
      />
      <RevTabItem
        :active="activeTab === 'items'"
        :label="i18n(translations.sellerPageItemsTab)"
        @click="activeTab = 'items'"
      />
      <RevTabItem
        :active="activeTab === 'about'"
        :label="i18n(translations.sellerPageAboutTab)"
        @click="activeTab = 'about'"
      />
    </RevTabs>

    <ReviewsTab v-show="activeTab === 'reviews'" />
    <ItemsTab v-show="activeTab === 'items'" />
  </RevContainer>
</template>

<script setup lang="ts">
import { useRouteParams } from '#imports'
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import SkinnyBanner from '~/scopes/branding/components/SkinnyBanner/SkinnyBanner.vue'
import { useSkinnyBannerLoader } from '~/scopes/branding/components/SkinnyBanner/useSkinnyBanner'

import { useSellerProductListPage } from '../SellerProductListPage/composables/useSellerProductListPage'

import translations from './SellerPage.translations'
import ItemsTab from './components/ItemsTab/ItemsTab.vue'
import MainSellerInfo from './components/MainSellerInfo/MainSellerInfo.vue'
import ReviewsTab from './components/ReviewsTab/ReviewsTab.vue'

const i18n = useI18n()
const { uuid: sellerId } = useRouteParams()
const { load: loadSkinnyBannerData } = useSkinnyBannerLoader()
const activeTab = ref('reviews')

await loadSkinnyBannerData()
const { company, countryCode, country, rating, ageInMonths } =
  useSellerProductListPage(sellerId)

// For seller with ageInMonths < 12, we return 1 year instead of 0
const ageInYears = computed(() => {
  return Math.floor(ageInMonths.value / 12) || 1
})
</script>
